import script from "./Waitlist.vue?vue&type=script&setup=true&lang=ts"
export * from "./Waitlist.vue?vue&type=script&setup=true&lang=ts"

import "./Waitlist.vue?vue&type=style&index=0&id=47cfa75b&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47cfa75b"]])

export default __exports__